import { Heart } from 'lucide-react';

import { Button } from '@/shared/ui/button';

export const DonateButton = () => {
  return (
    <Button asChild>
      <a href="https://buymeacoffee.com/thefamilydots" target="_blank">
        <Heart color="red" fill="red" />
        Donate
      </a>
    </Button>
  );
};
